'use client';

import githubDarkStylesheet from 'highlight.js/styles/github-dark.min.css?url';
import githubStylesheet from 'highlight.js/styles/github.min.css?url';
import { useTheme } from 'next-themes';
import { useEffect } from 'react';

const HLJS_LINK_ID = 'hljs-theme-link';

function ensureLinkEl(): HTMLLinkElement {
  let el = document.getElementById(HLJS_LINK_ID) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.id = HLJS_LINK_ID;
    el.rel = 'stylesheet';
    document.head.appendChild(el);
  }
  return el;
}

export function HighlightStyleManager() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const el = ensureLinkEl();
    const isDark = resolvedTheme === 'dark';
    // Served from our own origin: the public widget runs on customers' sites,
    // and a third-party CDN request would hand their visitors' IPs to that CDN.
    const href = new URL(isDark ? githubDarkStylesheet : githubStylesheet, window.location.href)
      .href;
    if (el.href !== href) {
      el.href = href;
    }
  }, [resolvedTheme]);

  return null;
}

export default HighlightStyleManager;
